/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       clickToPlay: true,
//       controls: ["play-large", "play", "progress", "mute", "current-time", "fullscreen"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
  GENERAL - Footer Images
========================================================================== */
const footerImagesInit = function () {
  var footerImages = [];
  let images = document.querySelectorAll(".profile-img");

  if (!images) {
    return;
  }

  images.forEach((image, i) => {
    footerImages.push("url(" + image.getAttribute("data-src") + ")");
  });

  let icons = document.querySelectorAll(".team-icon");
  icons.forEach((icon, i) => {
    icon.style.backgroundImage = footerImages[i];
  });
}; // footerImagesInit();
footerImagesInit();

/*  ==========================================================================
    GENERAL - Footer Animation
  ========================================================================== */

const footetBtn = document.querySelector(".btn--footer");
const footerLeader = document.querySelector(".sitefooter__cta__leader");

const footetBtnInit = function (footetBtn) {
  if (!footetBtn) {
    return;
  }

  footetBtn.addEventListener("mouseover", function () {
    footerLeader.classList.add("active");
  });

  footetBtn.addEventListener("mouseleave", function () {
    footerLeader.classList.remove("active");
  });
}; // footetBtnInit();
footetBtnInit(footetBtn);

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        setTimeout(function () {
          ScrollTrigger.refresh();
        }, 500);
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        setTimeout(function () {
          ScrollTrigger.refresh();
        }, 500);
      }
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
  GENERAL - Hide Autoplaying 
  ========================================================================== */

const videoBgs = document.querySelectorAll(".mediavideo");

const videoBGInit = function (videoBgs) {
  if (!videoBgs) {
    return;
  }

  $(".module--video").each(function (index) {
    $(this).on("click", function () {
      $(this).addClass("hide");
    });
  });
}; // videoBGInit();
videoBGInit(videoBgs);

/*  ==========================================================================
  GENERAL - Shuffle JS
  ========================================================================== */
window.onload = function () {
  var Shuffle = window.Shuffle;
  var element = document.querySelector(".shuffle-container");

  if (typeof element !== "undefined" && element !== null) {
    var shuffleInstance = new Shuffle(element, {
      itemSelector: "div"
    });

    $(".filter__pages li span").on("click", function (e) {
      e.preventDefault();
      $(".filter__pages li span").removeClass("active");
      $(this).addClass("active");
      var keyword = $(this).attr("data-target");
      shuffleInstance.filter(keyword);
      setTimeout(function () {
        ScrollTrigger.refresh();
      }, 500);
    });
  }
};

/*  ==========================================================================
    GENERAL - Services Offering
    ========================================================================== */

const priceSwitchYearly = $(".price-switch__yearly");
const priceSwitchMonthly = $(".price-switch__monthly");
const priceSwitchGBP = $(".price-switch__gbp");
const priceSwitchUSD = $(".price-switch__usd");
const priceSwitchEUR = $(".price-switch__eur");

const serviceOfferingInit = function () {
  priceSwitchYearly.on("click", function () {
    $(".offering").addClass("offering--yearly");
    $(".offering").removeClass("offering--monthly");

    $(".price-switch__yearly").addClass("active");
    $(".price-switch__monthly").removeClass("active");
  });

  priceSwitchMonthly.on("click", function () {
    $(".offering").removeClass("offering--yearly");
    $(".offering").addClass("offering--monthly");

    $(".price-switch__yearly").removeClass("active");
    $(".price-switch__monthly").addClass("active");
  });

  priceSwitchGBP.on("click", function () {
    $(".offering").addClass("offering--gbp");
    $(".offering").removeClass("offering--usd");
    $(".offering").removeClass("offering--eur");

    $(".price-switch__gbp").addClass("active");
    $(".price-switch__usd").removeClass("active");
    $(".price-switch__eur").removeClass("active");
  });

  priceSwitchUSD.on("click", function () {
    $(".offering").removeClass("offering--gbp");
    $(".offering").addClass("offering--usd");
    $(".offering").removeClass("offering--eur");

    $(".price-switch__gbp").removeClass("active");
    $(".price-switch__usd").addClass("active");
    $(".price-switch__eur").removeClass("active");
  });

  priceSwitchEUR.on("click", function () {
    $(".offering").removeClass("offering--gbp");
    $(".offering").removeClass("offering--usd");
    $(".offering").addClass("offering--eur");

    $(".price-switch__gbp").removeClass("active");
    $(".price-switch__usd").removeClass("active");
    $(".price-switch__eur").addClass("active");
  });

  if (typeof priceSwitchYearly !== "undefined") {
    priceSwitchYearly.trigger("click");
  }

  if (typeof priceSwitchGBP !== "undefined") {
    priceSwitchGBP.trigger("click");
  }
}; // serviceOfferingInit();
serviceOfferingInit();

/*  ==========================================================================
    GENERAL - Gated Form Validation
    ========================================================================== */

$(document).on("nfFormReady", function () {
  // Place events handlers here:
  $(".ninja-forms-field.nf-element").focusin(function () {
    $(this).closest(".field-wrap").addClass("focus");
  });
  $(".ninja-forms-field.nf-element").focusout(function () {
    $(this).closest(".field-wrap").removeClass("focus");
  });

  $("#nf-field-51").val($(".job__link__name").html());

  $("#nf-field-158").val(window.location.href);
});

/*  ==========================================================================
    GENERAL - User Interaction to reduce LCP
    ========================================================================== */

function detectUserInteraction() {
  document.getElementsByTagName("html")[0].classList.add("js-user-action");
}
detectUserInteraction();

/*  ==========================================================================
    GENERAL - Passive event listener polyfill. 
    ========================================================================== */
// This will prevent the error "preventDefault inside passive event listener invocation" from happening.
function passiveEventListenerPolyfill() {
  if (typeof EventTarget !== "undefined") {
    let func = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function (type, fn, capture) {
      this.func = func;
      if (typeof capture !== "boolean") {
        capture = capture || {};
        capture.passive = false;
      }
      this.func(type, fn, capture);
    };
  }
}
passiveEventListenerPolyfill();

/*  ==========================================================================
    PRICING MODULE - Toggle and FAQ (Native JS)
    ========================================================================== */

// PRICING MODULE - Toggle
function pricingModuleAddOn() {
  var modules = document.querySelectorAll(".service-offering--add-on");
  if (!modules.length) return;
  modules.forEach(function (root) {
    var toggle = root.querySelector("#billing-toggle");
    if (!toggle) return;
    var labels = root.querySelectorAll(".toggle__label");
    var isYearly = false; // Set to false to match initial UI state (monthly)
    function fmt(val) {
      var s = String(val).replace(/,/g, "");
      return Number(s).toLocaleString();
    }
    function updateCardPricing(card, monthly, yearly, annualTotal) {
      var amountEl = card.querySelector(".card__price .amount");
      var subtitleEl = card.querySelector(".card__subtitle");
      if (!amountEl || !subtitleEl) return;
      amountEl.dataset.monthly = monthly;
      amountEl.dataset.yearly = yearly;
      amountEl.textContent = "$" + fmt(isYearly ? yearly : monthly);
      subtitleEl.dataset.monthly = "Billed monthly";
      subtitleEl.dataset.yearly = "$" + annualTotal + " billed annually";
      subtitleEl.textContent = isYearly ? "$" + annualTotal + " billed annually" : "Billed monthly";
    }
    function refreshAllPrices() {
      root.querySelectorAll(".card__price .amount[data-monthly]").forEach(function (el) {
        el.textContent = "$" + fmt(el.dataset[isYearly ? "yearly" : "monthly"]);
      });
      root.querySelectorAll(".card__subtitle[data-monthly]").forEach(function (el) {
        el.textContent = el.dataset[isYearly ? "yearly" : "monthly"];
      });
    }
    toggle.addEventListener("click", function () {
      isYearly = !isYearly;
      toggle.classList.toggle("yearly", isYearly);
      labels.forEach(function (l) {
        l.classList.toggle("active", l.dataset.period === (isYearly ? "yearly" : "monthly"));
      });
      refreshAllPrices();
    });
    labels.forEach(function (l) {
      l.addEventListener("click", function () {
        var wantYearly = l.dataset.period === "yearly";
        if (wantYearly !== isYearly) toggle.click();
      });
    });
    var selector__credits = root.querySelector("#selector__credits");
    if (selector__credits) {
      selector__credits.addEventListener("change", function () {
        var opt = this.options[this.selectedIndex];
        var card = root.querySelector("#card-business");
        updateCardPricing(card, opt.dataset.monthly, opt.dataset.yearly, opt.dataset.annualTotal);
        var label = card.querySelector(".features__label");
        if (label) label.textContent = Number(this.value).toLocaleString() + " credits / month";
      });
    }
  });
}
pricingModuleAddOn();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

  const loadmoreBtn = document.querySelector(".paging__loadmore");
  const loadmoreContainer = document.querySelector(".loadmore-container");

  const loadmoreLoadPostsMultiplePages = function (pages) {

    if(pages && pages > 1){

      //Stopping default scroll back to previous position
      history.scrollRestoration = 'manual';

      const currentPage = new URL(window.location);
  
      //Creating an array on page numbers to map it
      var list = [];
      for (var i = 1; i < pages; i++) {
        list.push(i);
      }
  
      // Initialising the array of posts pages
      var postsHTML = [];

      const button = loadmoreBtn;
      const buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

      // Array of ajax calls
      var allAJAX = list.map(function(page){
          const data = {
            action: "loadmore",
            query: php_variables.posts, // that's how we get params from wp_localize_script() function
            page: page
          };
          //Updating the url to mtch the page number
          currentPage.searchParams.set('pagenum', page);
          return $.ajax({
            url: php_variables.ajax_url, // AJAX handler
            data: data,
            type: "POST",
            success: function (data) {
              postsHTML[page] = data;
            }
          });
      });

      // Waiting for all the ajax calls to be finished before proceeding
      Promise.all(allAJAX).then(function() {
        // Update current page variable
        php_variables.current_page = pages;

        button.textContent = buttonText; // set back to previous button text

        // Adding the new tiles to the dom
        list.map(page => {
          if(postsHTML[page]){
              loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
            }
        });

        // Updating the href for the loadmore button
        const nextPage = new URL(window.location);
        nextPage.searchParams.set('pagenum', parseInt(pages) + 1);
        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
          
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);

        // Scrolling the page to the last known position
        if(localStorage.getItem("scrollPosition")) {
          window.scroll({
            top: parseInt(localStorage.getItem("scrollPosition"), 10),
            behavior: "instant"
          });
        }
        
      });
    }
  };
  
  const loadmoreLoadPosts = function (e) {

    e.preventDefault(); // Preventing the a tag from redirecting to the page
    
    const button = this;
    const data = {
      action: "loadmore",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function
      page: php_variables.current_page
    };
    let buttonText; // create variable to store button text
  
    // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
    $.ajax({
      url: php_variables.ajax_url, // AJAX handler
      data: data,
      type: "POST",
      beforeSend: function (xhr) {
        buttonText = button.textContent; // store current button text
        button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
      },
      success: function (data) {
        if (data) {
          button.textContent = buttonText; // set back to previous button text 
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
          
          php_variables.current_page++;

          // Only push state to set the last page number or if there is more pages to load
          const currentPage = new URL(window.location);
          
          if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
            currentPage.searchParams.set('pagenum', php_variables.current_page);
            history.pushState({}, "", currentPage);
          }

          //Updating the loadmore link
          const nextPage = new URL(window.location);
          nextPage.searchParams.set('pagenum', parseInt(php_variables.current_page) + 1);

          button.href = nextPage;
  
          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            button.style.display = "none";
          }
          // Re-init links to make sure linklines on newly loaded content still work
          linksInit();
          // Re-init lazy load
          lazyLoadInstance.update(); // reinit lazy load after clones
          // Re-init effects
          const effects = document.querySelectorAll(".effect");
          effectsInit(effects);
          
        } else {
          button.style.display = "none"; // if no data, remove the button as well
        }
      }
    });
  }; // loadmoreLoadPosts();
  
  const loadmoreInit = function () {
    if (!loadmoreBtn) {
      return;
    }
    /** When adding fitering you will need to move this part into the filtering call */
    // Checking if the page paramenter is set
    const currentPage = new URL(window.location);
    let currentPageNum = currentPage.searchParams.get('pagenum');

    //If there is more than one page to load
    if(currentPageNum && currentPageNum > 1){    
      currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
      loadmoreLoadPostsMultiplePages(currentPageNum);
    }
    /** -end- */

    // Saving the scroll position before unload
    window.addEventListener("unload", function(e) {
      var scrollPosition = window.pageYOffset;
      localStorage.setItem("scrollPosition", scrollPosition);
    });
    
    loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
  }; // loadmoreInit();
  
  loadmoreInit();
/*  ==========================================================================
    Scroll Trigger Refreshes
    ========================================================================== */

jQuery(document).on("nfFormReady", function () {
  ScrollTrigger.refresh();
});

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

let hasAnimate = false; // has Visitor scrolled

const observer = Observer.create({
  // Observer to check if a scroll has happened
  target: window,
  type: "wheel,touch,scroll",
  onUp: () => {
    hasAnimate = true;
    observer.kill(); // We dont need the observer anymore when a scroll has happend
  },
  onDown: () => {
    hasAnimate = true;
    observer.kill(); // We dont need the observer anymore when a scroll has happend
  }
});
const effectsInit = function () {
  if (!effects) {
    return;
  }

  // animate each piece of homepage content
  gsap.utils.toArray(".effect").forEach((el, i) => {
    ScrollTrigger.create({
      id: `in-${i}`,
      trigger: el,
      start: "top 90%",
      end: "bottom 20%", // end was -50% that meant the end markers was -50% of the height of the browser out of view
      onEnter() {
        el.classList.add("effect--ready");
      },
      onEnterBack() {
        el.classList.add("effect--ready");
      },
      onLeave() {
        // onleave remove the class only if the vistor hasn't scrolled
        if (!hasAnimate) {
          el.classList.remove("effect--ready");
        }
      }
    });
  });
};
effectsInit();

/*  ==========================================================================
    Pinned List effect
    ========================================================================== */
const pinnedLists = document.querySelectorAll(".pinned-list");

const pinnedListsInit = function (pinnedLists) {
  if (!pinnedLists) {
    return;
  }

  pinnedLists.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
          $(".pinned-img__img").removeClass("active");
          $("." + val.dataset.swap).addClass("active");
        } else {
          val.classList.remove("effect--ready");
          $(".pinned-img__img").removeClass("active");
          $("." + val.dataset.swap).addClass("active");
        }
      },
      offset: "15%"
    });
  });
}; // pinnedListsInit();
pinnedListsInit(pinnedLists);

/*  ==========================================================================
    Pageheader with media feature effect
    ========================================================================== */
let targets = gsap.utils.toArray(".grow");

targets.forEach(target => {
  const grow2Tl = gsap.timeline({
    scrollTrigger: {
      trigger: target,
      scrub: 1.5,
      start: "top 95%",
      end: "top 30%",
      ease: "power1.out"
    }
  });
  grow2Tl.to(target, {
    duration: 1,
    scale: 1
  });
});

/*  ==========================================================================
    Siteheader Background effect
    ========================================================================== */
const sitheaderTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".siteheader__bg",
    scrub: 0.5,
    start: "top 5rem",
    end: "bottom 0",
    ease: "power1.out"
  }
});
sitheaderTl.to(".siteheader__bg", {
  duration: 0.1,
  opacity: 1,
  width: "105%",
  left: "-2.5%"
});

/*  ==========================================================================
    Page break effect
    ========================================================================== */
const pagebreakIcons = document.querySelectorAll(".pagebreak__ellipse");
if (pagebreakIcons.length) {
  var rotate = gsap
    .timeline({
      scrollTrigger: {
        trigger: ".main",
        scrub: 0.2,
        start: "top",
        end: "bottom 0"
      }
    })
    .to(".pagebreak__ellipse", {
      rotation: 360 * 5,
      duration: 1
    });
}

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const marqueeElements = document.querySelectorAll(".marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marquee__init = function () {
  if (!marqueeElements) {
    return;
  }

  window.addEventListener("resize", function () {
    marqueeElements.forEach(function (el) {
      // Setup animation times
      marquee__resize(el);
    });
  });

  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  marqueeElements.forEach(function (el) {
    // Wrapping the tiles
    el.innerHTML = "<div class='" + innerClass + "'>" + el.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });

    // Setup animation times
    marquee__resize(el);

    // Once everything is set up, add "loaded" class
    el.classList.add(elClass + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", marquee__init);

document.addEventListener("DOMContentLoaded", function () {
  const input = document.querySelector('[data-effect="type"]');
  const placeholderText = "Assign a task or ask anything...";
  let i = 0;

  function typePlaceholder() {
    if (i <= placeholderText.length) {
      input.setAttribute("placeholder", placeholderText.slice(0, i));
      i++;
      setTimeout(typePlaceholder, 50);
    }
  }

  typePlaceholder();
});



/*  ==========================================================================
    Chat Module - Animation
    ========================================================================== */
const chatModule__init = function () {
    (function (global) {
    'use strict';

    var DEFAULT_SIZE = 140;
    var REFERENCE_SIZE = 140;
    var MAX_DENSITY_SCALE = 3;
    var MAX_PARTICLE_SCALE = 2;
    var MAX_LINK_SCALE = 2.5;

    var ACCENT_GREEN = [118, 185, 0];

    var PALETTE_DARK = [
      [90, 140, 255],
      [110, 160, 255],
      [70, 120, 235],
      [130, 170, 255],
    ];

    var PALETTE_LIGHT = [
      [50, 100, 220],
      [70, 120, 230],
      [40, 90, 200],
      [80, 130, 240],
    ];

    var SHAPES = ['sphere', 'flower', 'cube', 'star', 'smile'];

    function getShapePoints(shape, cx, cy, count, scale) {
      var points = [];
      var s = scale;
      var i, angle, r, theta;

      if (shape === 'sphere') {
        for (i = 0; i < count; i += 1) {
          var phi = Math.acos(1 - (2 * (i + 0.5)) / count);
          theta = Math.PI * (1 + Math.sqrt(5)) * i;
          r = 38 * s;
          points.push({
            x: cx + r * Math.sin(phi) * Math.cos(theta),
            y: cy + r * Math.cos(phi) * 0.9,
          });
        }
      } else if (shape === 'flower') {
        for (i = 0; i < count; i += 1) {
          angle = (i / count) * Math.PI * 2 * 3;
          r = (12 + 26 * Math.abs(Math.sin(angle * 2.5))) * s;
          theta = (i / count) * Math.PI * 2;
          points.push({ x: cx + r * Math.cos(theta), y: cy + r * Math.sin(theta) });
        }
      } else if (shape === 'cube') {
        var cs = 28 * s;
        var edges = [
          [-1, -1, 1, -1],
          [-1, -1, -1, 1],
          [1, -1, 1, 1],
          [-1, 1, 1, 1],
          [-0.6, -0.6, 0.4, -0.6],
          [-0.6, -0.6, -0.6, 0.4],
          [1, -1, 0.4, -0.6],
          [1, 1, 0.4, 0.4],
          [-1, 1, -0.6, 0.4],
        ];
        var perEdge = Math.ceil(count / edges.length);
        for (var e = 0; e < edges.length; e += 1) {
          var x1 = edges[e][0], y1 = edges[e][1], x2 = edges[e][2], y2 = edges[e][3];
          for (var j = 0; j < perEdge && points.length < count; j += 1) {
            var t = j / perEdge;
            points.push({
              x: cx + (x1 + (x2 - x1) * t) * cs,
              y: cy + (y1 + (y2 - y1) * t) * cs,
            });
          }
        }
      } else if (shape === 'star') {
        for (i = 0; i < count; i += 1) {
          angle = (i / count) * Math.PI * 2;
          r = (i % 3 === 0 ? 38 : 16) * s;
          points.push({
            x: cx + r * Math.cos(angle - Math.PI / 2),
            y: cy + r * Math.sin(angle - Math.PI / 2),
          });
        }
      } else if (shape === 'smile') {
        var faceCount = Math.floor(count * 0.4);
        var eyeCount = Math.floor(count * 0.15);
        var mouthCount = count - faceCount - eyeCount * 2;
        for (i = 0; i < faceCount; i += 1) {
          angle = (i / faceCount) * Math.PI * 2;
          points.push({ x: cx + 36 * s * Math.cos(angle), y: cy + 36 * s * Math.sin(angle) });
        }
        for (i = 0; i < eyeCount; i += 1) {
          angle = (i / eyeCount) * Math.PI * 2;
          points.push({
            x: cx - 12 * s + 5 * s * Math.cos(angle),
            y: cy - 10 * s + 5 * s * Math.sin(angle),
          });
        }
        for (i = 0; i < eyeCount; i += 1) {
          angle = (i / eyeCount) * Math.PI * 2;
          points.push({
            x: cx + 12 * s + 5 * s * Math.cos(angle),
            y: cy - 10 * s + 5 * s * Math.sin(angle),
          });
        }
        for (i = 0; i < mouthCount; i += 1) {
          angle = (i / mouthCount) * Math.PI;
          points.push({
            x: cx + 18 * s * Math.cos(angle + Math.PI),
            y: cy + 8 * s + 12 * s * Math.sin(angle + Math.PI) * -1,
          });
        }
      }

      while (points.length < count) {
        points.push({
          x: cx + (Math.random() - 0.5) * 20 * s,
          y: cy + (Math.random() - 0.5) * 20 * s,
        });
      }
      return points.slice(0, count);
    }

    function mount(canvas, options) {
      if (!canvas || !canvas.getContext) {
        throw new Error('NetworkOrb.mount: first argument must be a <canvas> element');
      }
      var opts = options || {};

      var size = typeof opts.size === 'number' ? opts.size : DEFAULT_SIZE;
      var resolvedWidth = typeof opts.width === 'number' ? opts.width : size;
      var resolvedHeight = typeof opts.height === 'number' ? opts.height : size;
      var dark = opts.isDark === undefined ? true : !!opts.isDark;
      var interactive = opts.interactive === undefined ? true : !!opts.interactive;

      var scale = Math.min(resolvedWidth, resolvedHeight) / REFERENCE_SIZE;

      var ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('NetworkOrb.mount: 2d canvas context unavailable');

      var dpr = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
      canvas.width = resolvedWidth * dpr;
      canvas.height = resolvedHeight * dpr;
      canvas.style.width = resolvedWidth + 'px';
      canvas.style.height = resolvedHeight + 'px';
      canvas.style.display = 'block';
      canvas.style.filter =
        'drop-shadow(0 0 24px ' +
        (dark ? 'rgba(120, 130, 230, 0.22)' : 'rgba(75, 73, 218, 0.18)') +
        ')';
      if (interactive) canvas.style.cursor = 'pointer';
      ctx.scale(dpr, dpr);

      var cx = resolvedWidth / 2;
      var cy = resolvedHeight / 2;
      var palette = dark ? PALETTE_DARK : PALETTE_LIGHT;
      var accent = ACCENT_GREEN;
      var s = scale;

      var time = 0;
      var animId = 0;
      var particles = [];
      var greenIndices = [];
      var clickedCount = 0;
      var gameState = 'playing';
      var animPhase = 0;
      var currentShape = 0;
      var shapeHold = 0;
      var flash = 0;
      var round = 0;

      var densityScale = Math.min(s, MAX_DENSITY_SCALE);
      var particleScaleCap = Math.min(s, MAX_PARTICLE_SCALE);
      var linkScaleCap = Math.min(s, MAX_LINK_SCALE);
      var leftCount = Math.round(14 * densityScale);
      var rightCount = Math.round(10 * densityScale);
      var orbitCount = Math.round(20 * densityScale);
      var scatterCount = Math.round(30 * densityScale);

      var i, angle, radius;

      for (i = 0; i < leftCount; i += 1) {
        particles.push({
          x: cx - 20 * s + Math.random() * 14 * s,
          y: cy - 25 * s + Math.random() * 50 * s,
          vx: (Math.random() - 0.5) * 0.12 * s,
          vy: (Math.random() - 0.5) * 0.12 * s,
          size: (1.2 + Math.random() * 1.5) * particleScaleCap,
          opacity: 0.5 + Math.random() * 0.5,
          pulse: Math.random() * Math.PI * 2,
          pulseSpeed: 0.012 + Math.random() * 0.02,
          colorIdx: Math.floor(Math.random() * palette.length),
          isGreen: false,
          clicked: false,
        });
      }

      for (i = 0; i < rightCount; i += 1) {
        particles.push({
          x: cx + 10 * s + Math.random() * 8 * s,
          y: cy - 25 * s + Math.random() * 50 * s,
          vx: (Math.random() - 0.5) * 0.12 * s,
          vy: (Math.random() - 0.5) * 0.12 * s,
          size: (1.2 + Math.random() * 1.5) * particleScaleCap,
          opacity: 0.5 + Math.random() * 0.5,
          pulse: Math.random() * Math.PI * 2,
          pulseSpeed: 0.012 + Math.random() * 0.02,
          colorIdx: Math.floor(Math.random() * palette.length),
          isGreen: false,
          clicked: false,
        });
      }

      for (i = 0; i < orbitCount; i += 1) {
        angle = (i / orbitCount) * Math.PI * 2;
        radius = (35 + Math.random() * 25) * s;
        particles.push({
          x: cx + Math.cos(angle) * radius,
          y: cy + Math.sin(angle) * radius,
          vx: (Math.random() - 0.5) * 0.25 * s,
          vy: (Math.random() - 0.5) * 0.25 * s,
          size: (0.7 + Math.random() * 1.2) * particleScaleCap,
          opacity: 0.25 + Math.random() * 0.4,
          pulse: Math.random() * Math.PI * 2,
          pulseSpeed: 0.01 + Math.random() * 0.015,
          colorIdx: Math.floor(Math.random() * palette.length),
          isGreen: false,
          clicked: false,
        });
      }

      for (i = 0; i < scatterCount; i += 1) {
        angle = Math.random() * Math.PI * 2;
        radius = Math.random() * 55 * s;
        particles.push({
          x: cx + Math.cos(angle) * radius,
          y: cy + Math.sin(angle) * radius,
          vx: (Math.random() - 0.5) * 0.18 * s,
          vy: (Math.random() - 0.5) * 0.18 * s,
          size: (0.6 + Math.random() * 1.0) * particleScaleCap,
          opacity: 0.2 + Math.random() * 0.4,
          pulse: Math.random() * Math.PI * 2,
          pulseSpeed: 0.008 + Math.random() * 0.02,
          colorIdx: Math.floor(Math.random() * palette.length),
          isGreen: false,
          clicked: false,
        });
      }

      function getGreenCount() {
        var total = particles.length;
        return Math.min(3 + round, Math.max(3, Math.floor(total * 0.4)));
      }

      function resetGreenDots() {
        var p, k;
        for (k = 0; k < particles.length; k += 1) {
          p = particles[k];
          p.isGreen = false;
          p.clicked = false;
          p.targetX = undefined;
          p.targetY = undefined;
        }
        if (!interactive) {
          greenIndices = [];
          gameState = 'playing';
          return;
        }
        var indices = {};
        var gc = Math.min(getGreenCount(), particles.length);
        var found = 0;
        while (found < gc) {
          var idx = Math.floor(Math.random() * particles.length);
          if (!indices[idx]) {
            indices[idx] = true;
            found += 1;
          }
        }
        greenIndices = Object.keys(indices).map(Number);
        for (k = 0; k < greenIndices.length; k += 1) {
          particles[greenIndices[k]].isGreen = true;
          particles[greenIndices[k]].clicked = false;
        }
        clickedCount = 0;
        gameState = 'playing';
        round += 1;
      }

      resetGreenDots();

      var boundaryRadius = 65 * s;
      var baseConnDist = 30 * linkScaleCap;
      var animConnDist = 22 * linkScaleCap;

      function animate() {
        time += 1;
        ctx.clearRect(0, 0, resolvedWidth, resolvedHeight);

        var p, k;

        if (gameState === 'animating') {
          animPhase = Math.min(1, animPhase + 0.012);
          for (k = 0; k < particles.length; k += 1) {
            p = particles[k];
            if (p.targetX !== undefined && p.targetY !== undefined) {
              p.x += (p.targetX - p.x) * 0.06;
              p.y += (p.targetY - p.y) * 0.06;
            }
            p.pulse += p.pulseSpeed * 2;
          }

          if (flash > 0) {
            flash -= 0.02;
            var fg = ctx.createRadialGradient(cx, cy, 0, cx, cy, 70 * s);
            fg.addColorStop(0, 'rgba(' + accent[0] + ', ' + accent[1] + ', ' + accent[2] + ', ' + flash * 0.3 + ')');
            fg.addColorStop(1, 'rgba(' + accent[0] + ', ' + accent[1] + ', ' + accent[2] + ', 0)');
            ctx.beginPath();
            ctx.fillStyle = fg;
            ctx.arc(cx, cy, 70 * s, 0, Math.PI * 2);
            ctx.fill();
          }

          if (animPhase >= 1) {
            shapeHold += 1;
            if (shapeHold > 120) {
              gameState = 'cooldown';
              animPhase = 0;
              shapeHold = 0;
            }
          }
        } else if (gameState === 'cooldown') {
          animPhase = Math.min(1, animPhase + 0.015);
          for (k = 0; k < particles.length; k += 1) {
            p = particles[k];
            var dxc = cx - p.x;
            var dyc = cy - p.y;
            p.vx += dxc * 0.0008;
            p.vy += dyc * 0.0008;
            p.x += p.vx;
            p.y += p.vy;
            p.vx *= 0.98;
            p.vy *= 0.98;
            p.pulse += p.pulseSpeed;
          }
          if (animPhase >= 1) {
            resetGreenDots();
            animPhase = 0;
          }
        } else {
          for (k = 0; k < particles.length; k += 1) {
            p = particles[k];
            p.x += p.vx;
            p.y += p.vy;
            p.pulse += p.pulseSpeed;
            var dx0 = cx - p.x;
            var dy0 = cy - p.y;
            var dist = Math.sqrt(dx0 * dx0 + dy0 * dy0);
            if (dist > boundaryRadius) {
              p.vx += dx0 * 0.0003;
              p.vy += dy0 * 0.0003;
            }
            p.vx *= 0.999;
            p.vy *= 0.999;
          }
        }

        var connDist = gameState === 'animating' ? animConnDist : baseConnDist;
        for (i = 0; i < particles.length; i += 1) {
          for (var j = i + 1; j < particles.length; j += 1) {
            var dx = particles[i].x - particles[j].x;
            var dy = particles[i].y - particles[j].y;
            var d = Math.sqrt(dx * dx + dy * dy);
            if (d < connDist) {
              var alpha = (1 - d / connDist) * (gameState === 'animating' ? 0.35 : 0.18);
              var anyGreen = particles[i].isGreen || particles[j].isGreen;
              var c = gameState === 'animating' || anyGreen ? accent : palette[particles[i].colorIdx];
              ctx.beginPath();
              ctx.strokeStyle = 'rgba(' + c[0] + ', ' + c[1] + ', ' + c[2] + ', ' + alpha + ')';
              ctx.lineWidth = gameState === 'animating' ? 0.8 : 0.5;
              ctx.moveTo(particles[i].x, particles[i].y);
              ctx.lineTo(particles[j].x, particles[j].y);
              ctx.stroke();
            }
          }
        }

        for (k = 0; k < particles.length; k += 1) {
          p = particles[k];
          var a = p.opacity * (0.6 + 0.4 * Math.sin(p.pulse));
          var isGreenDot = p.isGreen && !p.clicked && gameState === 'playing';
          var isAnimating = gameState === 'animating';
          var c2;
          if (isAnimating) {
            c2 = accent;
          } else if (isGreenDot) {
            c2 = accent;
          } else if (p.clicked && gameState === 'playing') {
            c2 = accent;
          } else {
            c2 = palette[p.colorIdx];
          }

          var drawSize;
          if (isGreenDot) {
            drawSize = p.size * 1.8 + Math.sin(time * 0.08) * 0.6;
          } else if (isAnimating) {
            drawSize = p.size * 1.3;
          } else {
            drawSize = p.size;
          }

          var grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, drawSize * 3.5);
          grad.addColorStop(0, 'rgba(' + c2[0] + ', ' + c2[1] + ', ' + c2[2] + ', ' + a * (isGreenDot ? 0.5 : 0.35) + ')');
          grad.addColorStop(1, 'rgba(' + c2[0] + ', ' + c2[1] + ', ' + c2[2] + ', 0)');
          ctx.beginPath();
          ctx.fillStyle = grad;
          ctx.arc(p.x, p.y, drawSize * 3.5, 0, Math.PI * 2);
          ctx.fill();

          ctx.beginPath();
          ctx.fillStyle = 'rgba(' + c2[0] + ', ' + c2[1] + ', ' + c2[2] + ', ' + (isGreenDot ? 1 : a) + ')';
          ctx.arc(p.x, p.y, drawSize, 0, Math.PI * 2);
          ctx.fill();

          if (isGreenDot) {
            ctx.beginPath();
            ctx.strokeStyle = 'rgba(' + accent[0] + ', ' + accent[1] + ', ' + accent[2] + ', ' + (0.4 + 0.3 * Math.sin(time * 0.06)) + ')';
            ctx.lineWidth = 0.6;
            ctx.arc(p.x, p.y, drawSize + 3 * Math.min(s, 2), 0, Math.PI * 2);
            ctx.stroke();
          }
        }

        if (gameState !== 'animating') {
          var cp = 0.06 + 0.03 * Math.sin(time * 0.015);
          var cg = ctx.createRadialGradient(cx, cy, 0, cx, cy, 45 * s);
          cg.addColorStop(0, 'rgba(' + palette[0][0] + ', ' + palette[0][1] + ', ' + palette[0][2] + ', ' + cp + ')');
          cg.addColorStop(0.5, 'rgba(' + palette[1][0] + ', ' + palette[1][1] + ', ' + palette[1][2] + ', ' + cp * 0.5 + ')');
          cg.addColorStop(1, 'rgba(' + palette[2][0] + ', ' + palette[2][1] + ', ' + palette[2][2] + ', 0)');
          ctx.beginPath();
          ctx.fillStyle = cg;
          ctx.arc(cx, cy, 45 * s, 0, Math.PI * 2);
          ctx.fill();
        } else {
          var cp2 = 0.1 + 0.05 * Math.sin(time * 0.03);
          var cg2 = ctx.createRadialGradient(cx, cy, 0, cx, cy, 50 * s);
          cg2.addColorStop(0, 'rgba(' + accent[0] + ', ' + accent[1] + ', ' + accent[2] + ', ' + cp2 + ')');
          cg2.addColorStop(1, 'rgba(' + accent[0] + ', ' + accent[1] + ', ' + accent[2] + ', 0)');
          ctx.beginPath();
          ctx.fillStyle = cg2;
          ctx.arc(cx, cy, 50 * s, 0, Math.PI * 2);
          ctx.fill();
        }

        animId = global.requestAnimationFrame(animate);
      }

      function handleClick(ev) {
        if (!interactive || gameState !== 'playing') return;
        var rect = canvas.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return;
        var scaleX = resolvedWidth / rect.width;
        var scaleY = resolvedHeight / rect.height;
        var mx = (ev.clientX - rect.left) * scaleX;
        var my = (ev.clientY - rect.top) * scaleY;

        var hitRadius = 12 * Math.min(scale, MAX_LINK_SCALE);
        var hitRadius2 = hitRadius * hitRadius;

        for (var g = 0; g < greenIndices.length; g += 1) {
          var p = particles[greenIndices[g]];
          if (!p || p.clicked) continue;
          var dx = mx - p.x;
          var dy = my - p.y;
          if (dx * dx + dy * dy < hitRadius2) {
            p.clicked = true;
            clickedCount += 1;

            if (clickedCount >= greenIndices.length) {
              var shape = SHAPES[currentShape % SHAPES.length];
              currentShape += 1;
              var targets = getShapePoints(shape, cx, cy, particles.length, scale);
              for (var m = 0; m < particles.length; m += 1) {
                particles[m].targetX = targets[m].x;
                particles[m].targetY = targets[m].y;
                particles[m].isGreen = true;
              }
              gameState = 'animating';
              animPhase = 0;
              shapeHold = 0;
              flash = 1;
            }
            break;
          }
        }
      }

      if (interactive) canvas.addEventListener('click', handleClick);
      animate();

      return {
        destroy: function () {
          global.cancelAnimationFrame(animId);
          if (interactive) canvas.removeEventListener('click', handleClick);
        },
      };
    }

    function autoInit() {
      var nodes = document.querySelectorAll('[data-network-orb]');
      for (var i = 0; i < nodes.length; i += 1) {
        var el = nodes[i];
        if (el.__networkOrbMounted) continue;
        el.__networkOrbMounted = true;
        mount(el, {
          size: el.dataset.size ? parseFloat(el.dataset.size) : undefined,
          width: el.dataset.width ? parseFloat(el.dataset.width) : undefined,
          height: el.dataset.height ? parseFloat(el.dataset.height) : undefined,
          isDark: el.dataset.dark ? el.dataset.dark !== 'false' : undefined,
          interactive: el.dataset.interactive ? el.dataset.interactive !== 'false' : undefined,
        });
      }
    }

    var NetworkOrb = { mount: mount, getShapePoints: getShapePoints, autoInit: autoInit };

    if (typeof module !== 'undefined' && module.exports) {
      module.exports = NetworkOrb;
    }
    global.NetworkOrb = NetworkOrb;

    if (typeof document !== 'undefined') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', autoInit);
      } else {
        autoInit();
      }
    }
  })(typeof window !== 'undefined' ? window : this);

}

window.addEventListener("load", chatModule__init);
/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */
const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        ScrollTrigger.refresh();
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh scroll triggers on resize with slight delay
      setTimeout(function () {
        ScrollTrigger.refresh();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
			NAVIGATION - sitenav dropdowns
			========================================================================== */

const sitenav = document.querySelector(".siteheader");
const sitenavitems = sitenav.querySelectorAll("li[data-sitenavsection]");
const sitenavdropdown = document.querySelector(".sitenav__dropdown");
const sitenavBG = document.querySelector(".siteheader__bg");

const overclass = "sitenav__item--over";
const navopenbodyclass = "sitenavopen";
const activesectionclass = "sitenavsection--active";

var navopen = false;
var currentli = false;
var dropdownclosetimer = false;

// Check if isMobile, and only init if desktop or Ipad
if (!isMobile) {
  sitenav__init();
}

function sitenav__init() {
  // Check if is touchscreen and setup dropdown to show on tap as well as hover
  if (isTouchDevice) {
    // IF TOUCHSCREEN (e.g. Ipad users)...
    // Setup dropdown to show on tap
    sitenavitems.forEach(function (sitenavitem) {
      sitenavitem.addEventListener("click", function (e) {
        e.preventDefault();
        if (!this.classList.contains(overclass)) {
          navopen = false;
          sitenavitem__over(sitenavitem);
        } else {
          sitenav__out();
        }
      });
    });
  } else {
    // IF DESKTOP...
    sitenavitems.forEach(function (sitenavitem) {
      sitenavitem.addEventListener("mouseover", e => {
        sitenavitem__over(sitenavitem);
      });
      sitenavitem.addEventListener("mouseout", e => {
        sitenav__out();
      });
    });
    sitenavdropdown.addEventListener("mouseover", e => {
      dropdownsection__over();
    });
    sitenavdropdown.addEventListener("mouseout", e => {
      sitenav__out();
    });
  }
} // sitenav__init()

function sitenavitem__over(sitenavitem) {
  // On hover of sitenav item
  dropdownsection__open(sitenavitem);
} // sitenavitem__over()

function dropdownsection__open(target_li) {
  var target_section = sitenavdropdown.querySelector(".sitenavsection--" + target_li.dataset.sitenavsection);
  var dropdown_height = target_section.offsetHeight;

  // Make dropdown show and set classes to say it's open
  sitenavdropdown.style.height = dropdown_height + "px";
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to stop dropdown closing
    window.clearTimeout(dropdownclosetimer);
  }
  // Remove over class from any old clicks
  if (document.querySelector("." + overclass)) {
    document.querySelector("." + overclass).classList.remove(overclass);
  }
  // add over class to current li
  target_li.classList.add(overclass);
  document.querySelector("body").classList.add(navopenbodyclass);
  if (document.querySelector("." + activesectionclass)) {
    document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
  }
  target_section.classList.add(activesectionclass);
} //dropdownsection__open();

function dropdownsection__over() {
  // On hover of dropdownsection, keep the dropdown open
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to close the dropdown
    window.clearTimeout(dropdownclosetimer);
  }
  document.querySelector("body").classList.add(navopenbodyclass);
} // sitenavitem__over()

function sitenav__out() {
  // On leave sitenav hover
  navopen = false;
  // Start timeout to close sitenav dropdown
  dropdownclosetimer = window.setTimeout(sitenav__close, 250);
} // sitenavitem__over()

function sitenav__close() {
  // when time out ends and nav open is still false, close the sitenav
  if (!navopen) {
    // Set height to 0 and remove classes
    if (document.querySelector("." + activesectionclass)) {
      document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
    }
    document.querySelector("body").classList.remove(navopenbodyclass);
    if (document.querySelector("." + overclass)) {
      document.querySelector("." + overclass).classList.remove(overclass);
    }
    sitenavdropdown.style.height = 0;
  }
} // sitenav__close

window.addEventListener("scroll", function () {
  if (window.scrollY >= 50) {
    sitenavBG.classList.add("active");
  } else {
    sitenavBG.classList.remove("active");
  }
});
